import { SxProps } from '@mui/material';

export const seeAllReviewsButton: SxProps = {
	margin: 0,
	padding: 0,
	alignItems: 'baseline',
	flexWrap: 'wrap',
	display: 'inline',
	'&:hover': {
		backgroundColor: 'transparent',
		opacity: 1,
	},
};
